"use client";

import React from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import { Button, Modal, ModalContent } from "@heroui/react";
import { ChevronLeftIcon } from "@radix-ui/react-icons";

import { useMultistepForm } from "../../hooks/useMultistepForm";
import { useBuyA1XModal } from "../../contexts/BuyA1XModalContext";
import { BuyA1XSchema } from "../../validations/buyA1XSchema";
import { ChooseBuyTokens } from "./ChooseBuyTokens";
import { ReviewBuyA1X } from "./ReviewBuyA1X";

export const BuyA1XModal = () => {
  const { isOpen, closeModal } = useBuyA1XModal();

  const form = useForm({
    resolver: zodResolver(BuyA1XSchema),
    defaultValues: {
      slippage: 500, // 0.5% default slippage
    },
  });

  const { step, isFirstStep, isLastStep, back, next, reset } = useMultistepForm(
    [
      <ChooseBuyTokens key="choose" nextStep={() => next()} />,
      <ReviewBuyA1X key="review" />,
    ]
  );

  const handleClose = () => {
    closeModal();
    reset(); // Reset to first step
    form.reset(); // Reset form values
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) handleClose();
      }}
      size="md"
      placement="center"
    >
      <ModalContent className="p-6 ">
        <div className="flex flex-col w-full max-w-md mx-auto">
          {/* Header */}
          <div className="flex items-center justify-center relative mb-6">
            {!isFirstStep && (
              <Button
                className="absolute left-0 rounded-full bg-default-100 hover:bg-default-200"
                onClick={back}
                variant="light"
                size="sm"
                isIconOnly
              >
                <ChevronLeftIcon className="h-5 w-5 text-default-600" />
              </Button>
            )}
            <h2 className="text-xl font-bold text-center dark:text-white text-black">
              {isLastStep ? "Review Purchase" : "Buy A1X"}
            </h2>
          </div>

          {/* Form Content */}
          <FormProvider {...form}>
            <form className="w-full">{step}</form>
          </FormProvider>
        </div>
      </ModalContent>
    </Modal>
  );
};
